import { DataViewerModel } from '@leverege/molten/data-viewers'

import EventsView from '../events/EventsView'
import EventsViewModel from '../events/EventsViewModel'

import HeadCountSupportDataViewer from './HeadCountSupportDataViewer'

const id = 'tpi.dataViewers.HeadCountDataViewer'

export default {
  id,
  type : 'tpi.HeadCountData',
  name : 'Head Count',
  icon : 'fa fa-history fa-fw',
  location : [ 'main', 'card' ],
  matches : {
    type : [ 'ItemInfoDataViewer' ],
    objectType : 'moldHalf'
  },
  createSettings : ( props ) => {
    return EventsViewModel.create( {
      dataViewers : [
        DataViewerModel.create(
          HeadCountSupportDataViewer.type,
          HeadCountSupportDataViewer.createSettings( props )
        )
      ],
      breakpoints : [ 'minWidth' ]
    }, { getAllPages : false,
         options : {
           perPage : 100,
           range : 'last24Hours',
         }, } )
  },
  component : EventsView,
  getDefaultCardContentOptions : { height : '800px' }
}
